export const PROMOTION_APPLIED = 'PROMOTION_APPLIED';
export const PROMOTION_REMOVED = 'PROMOTION_REMOVED';
